import { render, staticRenderFns } from "./modalRealizarSoporte.vue?vue&type=template&id=b0e05158&"
import script from "./modalRealizarSoporte.vue?vue&type=script&lang=js&"
export * from "./modalRealizarSoporte.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports